import { useEffect, useRef } from 'react';

export function useScrollAnimation(options = {}) {
    const { threshold = 0.1, rootMargin = '0px' } = options;
    const ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target
                            .querySelectorAll('.scroll-animate, .scroll-animate-fade')
                            .forEach((el) => el.classList.add('animate-in'));
                    }
                });
            },
            { threshold, rootMargin }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => observer.disconnect();
    }, [threshold, rootMargin]);

    return ref;
}
